/**
 * Accessory Note Updates entity class
 */

/**
 * AccessoryNoteUpdatesFactory
 * returns AccessoryNoteUpdates entity class
 *
 * @class AccessoryNoteUpdatesFactory
 * @memberof mwApp
 * @see mwApp
 * @return {Function} {@link models.AccessoryNoteUpdates} class
 *
 * @ngdoc factory
 * @name mwApp.factory:AccessoryNoteUpdatesFactory
 */

/* @ngInject */
export default function AccessoryNoteUpdatesFactory (Entity) {
  /* === AccessoryNoteUpdates class === */

  /**
   * AccessoryNoteUpdates model
   *
   * @class AccessoryNoteUpdates
   * @classdesc AccessoryNoteUpdates model
   * @memberof models
   * @see models
   * @extends models.Entity
   * @return {models.AccessoryNoteUpdates} AccessoryNoteUpdates entity
   */
  function AccessoryNoteUpdates () {
    var obj = Entity.apply(this, arguments)
    if (obj) {
      return obj
    }
  }
  AccessoryNoteUpdates.prototype = Object.create(Entity.prototype)
  AccessoryNoteUpdates.prototype.constructor = AccessoryNoteUpdates

  /* === AccessoryNoteUpdates instance methods & fields === */

  Object.assign(AccessoryNoteUpdates.prototype, {

    /**
     * instance fields
     *
     * @memberof models.AccessoryNoteUpdates#
     * @type {Object}
     */
    _fields: {
      id: Number,
      entityId: Number,
      diff: null,
      operation: {
        name: String,
        description: String
      },
      updatedTime: String,
      updatedBy: String
    },

    /**
     * url template
     *
     * @memberof models.AccessoryNoteUpdates#
     * @type {String}
     */
    _urlTemplate: 'api/accessory-notes/audit',

    /**
     * public url template
     *
     * @memberof models.AccessoryNoteUpdates#
     * @type {String}
     */
    _publicUrlTemplate: 'subscribers/{{subscriber.id}}/AccessoryNoteUpdatess/{{::id}}'
  })

  /* === AccessoryNoteUpdates static methods & fields === */

  // copy all static methods from Entity class
  Object.assign(AccessoryNoteUpdates, Entity)
  AccessoryNoteUpdates._name = 'AccessoryNoteUpdates'
  AccessoryNoteUpdates.init()

  // permissions
  AccessoryNoteUpdates.access = {
  }

  return AccessoryNoteUpdates
}
